// src/features/residents/routes.tsx
import { Navigate, RouteObject } from "react-router-dom";
import ResidentLayout from "./layout/ResidentLayout";
import ResidentDashboard from "./screens/ResidentDashboard";
import AnnouncementsPage from "./screens/AnnouncementsPage";
import NotificationsPage from "./screens/NotificationsPage";
import PollingPage from "./screens/PollingPage";
import IssuesPage from "./screens/IssuesPage";
import PaymentsPage from "./screens/PaymentsPage";
import ProfilePage from "./screens/ProfilePage";
import DocumentsPage from "@/components/documents/DocumentsPage";
import AppErrorBoundary from "@/components/AppErrorBoundary";
import { VOTING_ENABLED } from "@/lib/featureFlags";

export const residentRoutes: RouteObject = {
  path: "/resident",
  element: <ResidentLayout />,
  // Previously missing: a render-time throw anywhere under /resident (e.g.
  // an unguarded `membership.building.name`) had no boundary above it and no
  // fallback below RouterProvider either, so it reached the browser as a
  // blank screen with no error UI at all.
  errorElement: <AppErrorBoundary />,
  children: [
    { index: true, element: <ResidentDashboard /> },
    { path: "announcements", element: <AnnouncementsPage /> },
    { path: "notifications", element: <NotificationsPage /> },
    { path: "documents", element: <DocumentsPage /> },
    // Hidden until the next milestone (lib/featureFlags.ts). Kept as a
    // redirect rather than removed: the tab was live, so the path may be
    // bookmarked or already sent to someone, and a dead route inside the
    // layout renders an error screen rather than a missing page.
    {
      path: "polling",
      element: VOTING_ENABLED ? <PollingPage /> : <Navigate to="/resident" replace />,
    },
    { path: "issues", element: <IssuesPage /> },
    // Reporting is a sheet on the issues page now. The route stays as a
    // redirect: it was the target of the dashboard's quick action for two
    // releases and may be bookmarked, and a 404 is a worse answer than the
    // form opening where it now lives.
    { path: "issues/new", element: <Navigate to="/resident/issues?new=1" replace /> },
    { path: "payments", element: <PaymentsPage /> },
    { path: "profile", element: <ProfilePage /> },
  ],
};
